import styled from 'styled-components';
import WheelchairsAvailableIconSvg from '../../assets/hotels/amenities/WheelchairsAvailable.svg';

const WheelchairsAvailableIcon = styled(
  WheelchairsAvailableIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default WheelchairsAvailableIcon;
